import React, { useState } from 'react';
import DataTable from '../../../components/DataTable';
import EditModal from '../../../components/EditModal';
import { editDonorSchema } from '../../../formData/editDonorSchema';
import { showSuccess } from '../../../components/showSuccess';
import Tooltip from '../../../components/Tooltip';
import DownClickablePopup from '../../../components/DownClickablePopup';
import DynamicForm from '../../../components/dynamicForm';
import { donationFilterSchema } from '../../../formData/donationFilterSchema';
import { Link } from 'react-router-dom';

let sampleData = [
    {
        id: '001',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Active',
        status: 'Active',
        statusColor: '#16a34a',
    },
    {
        id: '002',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Active',
        status: 'Active',
        statusColor: '#16a34a',
    },
    {
        id: '003',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Inactive',
        status: 'Inactive',
        statusColor: '#facc15',
    },
    {
        id: '004',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Active',
        status: 'Active',
        statusColor: '#16a34a',
    },
    {
        id: '005',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Active',
        status: 'Active',
        statusColor: '#16a34a',
    },
    {
        id: '006',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Active',
        status: 'Active',
        statusColor: '#16a34a',
    },
    {
        id: '007',
        customer: 'John Doe',
        contact: 'johndoe@gmail.com\n+00 0000000000',
        time: '04/08/2025 08:00am',
        donationFor: 'Type: New Program\nPrograms',
        amount: '$1000.00',
        modifier: 'Match Fee',
        method: 'AID PAY CC',
        nextGiftDate: '05/07/2025',
        subscriptionStatus: 'Active',
        status: 'Active',
        statusColor: '#16a34a',
    },
];

export default function SubscriptionPage() {
    const [search, setSearch] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [editData, setEditData] = useState({});
    const [sortOption, setSortOption] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [filterOption, setFilterOption] = useState(null);

    const sortOptions = [
        'Donation Time - Ascending',
        'Donation Time - Descending',
        'Donation Amount - Ascending',
        'Donation Amount - Descending',
    ];

    const filterOptions = [
        'All Statuses',
        'Active',
        'Inactive',
    ];

    const handleSortChange = (option) => {
        setSortOption(option);
    };

    const handleFilterChange = (option) => {
        setFilterOption(option);
    };

    const sortedData = [...sampleData].sort((a, b) => {
        if (!sortOption) return 0;
        switch (sortOption) {
            case 'Donation Time - Ascending':
                return new Date(a.time) - new Date(b.time);
            case 'Donation Time - Descending':
                return new Date(b.time) - new Date(a.time);
            case 'Donation Amount - Ascending':
                return parseFloat(a.amount.replace('$', '')) - parseFloat(b.amount.replace('$', ''));
            case 'Donation Amount - Descending':
                return parseFloat(b.amount.replace('$', '')) - parseFloat(a.amount.replace('$', ''));
            default:
                return 0;
        }
    });

    const filteredData = sortedData.filter(d => {
        if (!filterOption || filterOption === 'All Statuses') return true;
        return d.status === filterOption;
    }).filter(d =>
        d.customer.toLowerCase().includes(search.toLowerCase())
    );

    const columns = [
        { key: 'customer', title: 'Customer Name' },
        { key: 'contact', title: 'Customer Email/Phone Number' },
        { key: 'time', title: 'Donation Time' },
        { key: 'donationFor', title: 'Donation For' },
        { key: 'amount', title: 'Donation Amount' },
        { key: 'modifier', title: 'Payment Modifier' },
        { key: 'method', title: 'Payment Method' },
        { key: 'nextGiftDate', title: 'Next Gift Date' },
        { key: 'subscriptionStatus', title: 'Subscription Status' },
        {
            key: 'status',
            title: 'Status',
            render: (_, row) => (
                <div className="flex items-center">
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={row.status === 'Active'}
                            onChange={() => {
                                const newStatus = row.status === 'Active' ? 'Inactive' : 'Active';
                                const newStatusColor = newStatus === 'Active' ? '#16a34a' : '#facc15';
                                row.status = newStatus;
                                row.statusColor = newStatusColor;
                                row.subscriptionStatus = newStatus;
                            }}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            ),
        },
        {
            key: 'actions',
            title: 'Action',
            className: styles.actionsCell,
            render: (_, row) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button style={styles.actionBtn} title="Edit" onClick={() => handleEdit(row)}>
                        <span className="material-icons">edit</span>
                    </button>
                    <Link to={`/admin/subscription/details/${row.id}`} style={{ textDecoration: 'none' }}>
                        <button style={styles.actionBtn} title="View">
                            <span className="material-icons">visibility</span>
                        </button>
                    </Link>
                    <button style={styles.actionBtn} title="Download">
                        <span className="material-icons">download</span>
                    </button>
                </div>
            ),
        },
    ];

    const handleEdit = (row) => {
        setEditData(row);
        setModalVisible(true);
    };

    const handleClose = () => {
        setModalVisible(false);
    };

    const handleUpdate = async (updatedRow) => {
        console.log('Updated row:', updatedRow);
        setModalVisible(false);
        await showSuccess('Donor Details Updated Successfully!');
    };

    const sortHtml = sortOptions.map((option, index) => (
        <div
            key={index}
            className={`sort-option ${sortOption === option ? 'sort-option-selected' : ''}`}
            onClick={() => handleSortChange(option)}
        >
            <span className="sort-option-radio"></span>
            <span>{option}</span>
        </div>
    ));

    const filterHtml = filterOptions.map((option, index) => (
        <div
            key={index}
            className={`sort-option ${filterOption === option ? 'sort-option-selected' : ''}`}
            onClick={() => handleFilterChange(option)}
        >
            <span className="sort-option-radio"></span>
            <span>{option}</span>
        </div>
    ));

    return (
        <>
            <EditModal
                visible={modalVisible}
                schema={editDonorSchema}
                initialData={editData}
                onClose={handleClose}
                onSubmit={handleUpdate}
            />
            <div style={styles.container}>
                <div style={styles.toolbar}>
                    <h1 style={styles.title}>Subscriptions</h1>
                    <div style={styles.rightSideFilter}>
                        <div style={styles.searchWrapper}>
                            <span className="material-icons" style={styles.searchIcon}>search</span>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                style={styles.searchInput}
                            />
                        </div>
                        <DownClickablePopup popUpTitle={'Filter'} filters={filterHtml}>
                            <button style={styles.iconBtn}>
                                <span className="material-icons">filter_list</span>
                            </button>
                        </DownClickablePopup>
                        <DownClickablePopup popUpTitle={'Sort'} filters={sortHtml}>
                            <button style={styles.iconBtn}>
                                <span className="material-icons">sort</span>
                            </button>
                        </DownClickablePopup>
                    </div>
                </div>
                <DataTable data={filteredData} columns={columns} rowKey="id" />
            </div>
        </>
    );
}

const styles = {
    container: {
        margin: '0 auto',
        color: '#333',
    },
    title: {
        fontSize: 24,
        marginTop: 0,
        color: '#4a5568',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px',
        flexDirection: 'row',
    },
    searchWrapper: {
        position: 'relative',
        width: 240,
    },
    searchIcon: {
        position: 'absolute',
        top: '8px',
        left: '8px',
        color: 'rgb(153, 153, 153)',
    },
    searchInput: {
        width: '100%',
        padding: '10px 9px 10px 32px',
        borderRadius: '4px',
        border: '1px solid rgb(204, 204, 204)',
        fontSize: '16px',
    },
    iconBtn: {
        cursor: 'pointer',
        fontSize: '24px',
        color: 'rgb(0, 0, 0)',
        background: '#fff',
        display: 'flex',
        padding: '5px',
        border: 'solid 1px #ccc',
    },
    statusDot: {
        display: 'inline-block',
        width: 12,
        height: 12,
        borderRadius: '50%',
        marginRight: 6,
    },
    statusText: {
        fontSize: 12,
        fontWeight: '500',
        marginRight: 6,
        verticalAlign: 'middle',
    },
    idText: {
        fontSize: 12,
        color: '#000',
        marginTop: 4,
    },
    actionBtn: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#555',
        marginRight: 8,
        fontSize: 18,
    },
    rightSideFilter: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
};